import { useDownloadPublicPaymentReceiptPdfMutation } from '@massilia/queries'

import { PaymentReceiptActions } from '@/components/payment-confirmation/payment-receipt-actions'

import { SimplePaymentConfirmation } from './simple-payment-confirmation'

const DEPOSIT_STRINGS = {
  failedDescription:
    "Votre paiement d'acompte n'a pas pu être traité. Veuillez réessayer ou contacter votre banque si le problème persiste.",
  failedTitle: "Paiement de l'acompte échoué",
  successDescriptionBuilder: (amountLabel?: string, referenceLabel?: string) =>
    `Votre acompte${amountLabel ? ` de ${amountLabel}` : ''}${referenceLabel ?? ''} a bien été enregistré. Vous recevrez une confirmation par email sous peu.`,
  successTitle: 'Acompte reçu !',
  unknownDescription:
    "Nous n'avons pas pu confirmer l'état de votre paiement d'acompte. Vérifiez votre espace client ou contactez notre équipe si besoin.",
  unknownTitle: 'Statut de paiement indisponible',
} as const

interface DepositPaymentConfirmationProps {
  transId?: string
  amountCents?: number
  reference?: string
  status: 'failed' | 'success' | 'unknown'
}

export function DepositPaymentConfirmation({
  transId,
  amountCents,
  reference,
  status,
}: DepositPaymentConfirmationProps) {
  const downloadReceiptMutation = useDownloadPublicPaymentReceiptPdfMutation()

  const handleDownloadReceipt = async () => {
    if (!transId) {
      throw new Error('missing transId')
    }
    return downloadReceiptMutation.mutateAsync(transId)
  }

  const extraActions = transId ? (
    <PaymentReceiptActions
      isLoading={downloadReceiptMutation.isPending}
      onDownload={handleDownloadReceipt}
    />
  ) : undefined

  return (
    <SimplePaymentConfirmation
      amountCents={amountCents}
      extraActions={extraActions}
      reference={reference}
      retryLink="/payer-acompte"
      status={status}
      strings={DEPOSIT_STRINGS}
    />
  )
}
